export const PRI_LANG_FI	= 0;
export const PRI_LANG_EN	= 1;
export const PRI_LANG_SWE	= 2;
export const PRI_LANG_SCI	= 3;
export const PRI_LANG_ABBR	= 4;

export const SEC_LANG_NONE	= 0;
export const SEC_LANG_FI	= 1;
export const SEC_LANG_EN	= 2;
export const SEC_LANG_SWE	= 3;
export const SEC_LANG_SCI	= 4;
export const SEC_LANG_ABBR	= 5;

export const CITY_LANG_FI	= 0;
export const CITY_LANG_EN	= 1;
export const CITY_LANG_SWE	= 2;

export const monthNames = [
	'months.January', 
	'months.February', 
	'months.March', 
	'months.April', 
	'months.May', 
	'months.June', 
	'months.July', 
	'months.August', 
	'months.September', 
	'months.October', 
	'months.November', 
	'months.December'
];

export const monthNamesShort = [
	'months.Jan', 
	'months.Feb', 
	'months.Mar',
	'months.Apr',
	'months.May_short',
	'months.Jun', 
	'months.Jul',
	'months.Aug',
	'months.Sep',
	'months.Oct',
	'months.Nov',
	'months.Dec'
];

export const dayNames = [
	'days.Monday',
	'days.Tuesday',
	'days.Wednesday',
	'days.Thursday',
	'days.Friday',
	'days.Saturday',
	'days.Sunday'
];

export const dayNamesShort = [
	'days.Mon',
	'days.Tue',
	'days.Wed',
	'days.Thu',
	'days.Fri',
	'days.Sat',
	'days.Sun'
];

export function getCityName(city, user) {
	let n;

	if (!city) {
		console.error('getCityName: NULL city!');
		return '';
	}

	if (!user) {
		console.error('getCityName: null user!');
		return city.fi;
	}

// 	console.log('getCityName', city, user);

	n = null;

	switch (user.city_lang) {
		case CITY_LANG_FI:
			n = city.fi;
			break;
		case CITY_LANG_EN:
			n = city.en;
			break;
		case CITY_LANG_SWE:
			n = city.swe;
			break;
		default:
			console.error('getCityName: user has invalid city language', user.city_lang);
			n = city.fi;
			break;
	}

	return n;
}

export function getShortSpecName(spec, user) {
	let n;

	if (!spec) {
		console.error('getShortSpecName: null spec!');
		return '';
	}

	if (!user) {
		console.error('getShortSpecName: null user!');
		return spec.fi;
	}

	n = null;

	switch (user.pri_spec_lang) {
		case PRI_LANG_FI:
			n = spec.fi;
			break;
		case PRI_LANG_EN:
			n = spec.en;
			break;
		case PRI_LANG_SWE:
			n = spec.swe;
			break;
		case PRI_LANG_SCI:
			n = spec.sci;
			break;
		case PRI_LANG_ABBR:
			n = spec.abbr;
			break;
		default:
			console.error('getShortSpecName: user has invalid primary species language', user.pri_spec_lang);
			n = spec.fi;
			break;
	}

	if (!n || !n.length)
		return spec.sci;

	return n;
}

export function getSpecName(spec, user) {
	let n, n2;

	if (!spec) {
		console.error('getSpecName: null spec!');
		return '';
	}

	if (!user) {
		console.error('getSpecName: null user!');
		return spec.fi;
	}

	n = getShortSpecName(spec, user);

	n2 = '';

	switch (user.sec_spec_lang) {
		case SEC_LANG_NONE:
			break;
		case SEC_LANG_FI:
			n2 = spec.fi;
			break;
		case SEC_LANG_EN:
			n2 = spec.en;
			break;
		case SEC_LANG_SWE:
			n2 = spec.swe;
			break;
		case SEC_LANG_SCI:
			n2 = spec.sci;
			break;
		case SEC_LANG_ABBR:
			n2 = spec.abbr;
			break;
		default:
			console.error('getSpecName: user has invalid secondary species language', user.sec_spec_lang);
			break;
	}

	if (n.length && n2.length)
		return n + ' (' + n2 + ')';

	if (n.length)
		return n;

	return '(' + n2 + ')';
}

export function getCountryName(country, user) {
	let n = null;

	if (!country) {
		console.error('getCountryName: null country!');
		return '';
	}

	if (!user) {
		console.error('getCountryName: null user!');
		return country.fi;
	}

	switch (user.city_lang) {
		case CITY_LANG_FI:
			n = country.fi;
			break;
		case CITY_LANG_EN:
			n = country.en;
			break;
		case CITY_LANG_SWE:
			n = country.swe;
			break;
		default:
			console.error('getCountryName: user has invalid city language', user.country_lang);
			n = country.fi;
			break;
	}

	return n;
}

